import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    floorplans: [],
    rooms: [],
    steps: [],
    loading: false,
    error: null,
    dataLoaded: false
};

const floorplanSlice = createSlice({
    name: 'floorplan',
    initialState,
    reducers: {
        setFloorplansData: (state, action) => {
            const { Floorplans, Rooms, Steps } = action.payload;

            console.log('Setting floorplans data:', {
                floorplans: Floorplans?.length || 0,
                rooms: Rooms?.length || 0,
                steps: Steps?.length || 0
            });

            // Filter to active floorplans only
            state.floorplans = (Floorplans || []).filter(plan => {
                const isActive = plan.Active === 1 || plan.active === 1;
                if (!isActive) {
                    console.log('Skipping inactive floorplan:', plan.Name || plan.name);
                }
                return isActive;
            });
            state.rooms = Rooms || [];
            state.steps = Steps || [];

            state.dataLoaded = true;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const { setFloorplansData, setLoading, setError } = floorplanSlice.actions;
export default floorplanSlice.reducer;
